import React from "react";

const Row = props => (
    <div className={(props.className ? `${props.className} ` : "") + "row"}
        id={props.id}>
        {props.children}
    </div>
);

export default Row;